import React from 'react';
import { FiChevronUp, FiDownload } from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import TextLoop from "react-text-loop";
import BlogContent from "../../unused/elements/blog/BlogContent"

import Helmet from "../../unused/component/common/Helmet";
import HeaderThree from "../HeaderThree";
import PortfolioList from "../Landing/PortfolioList";
import ServiceList from "../Landing/ServiceList";
import TabTwo from "../Landing/TabTwo";
import ContactThree from '../ContactThree';
import FooterTwo from '../../unused/component/footer/FooterTwo';
import ProfileSlide from './ProfileSlide';
import InterestList from '../Landing/InterestList';

const SlideList = [
    {
        textPosition: 'text-left',
        category: '',
        description: '',
        buttonText: '',
        buttonLink: ''
    }
]
const MainLandingPage = () => {
    let title = 'Who am I?',
        description = `From crafting seamless mobile experiences to building full-stack, data-intensive, and distributed systems, I’m a software engineer driven by turning ideas into reliable, real-world products. My journey began with hands-on product development at the Apple Developer Academy and has since taken me across the international financial technology landscape through roles at Bank BJB, Bank Central Asia (BCA), and ING. Along the way, I’ve worked on scalable digital products, software architecture, ETL and data platforms, as well as secure backend systems, while developing a growing interest in Site Reliability Engineering, AI-enabled systems, and hardware-software integration.
`;
    return (
        <div className="active-dark">
            <Helmet pageTitle="Bryan Kenneth's Website" />

            <HeaderThree homeLink="/" logo="symbol-dark" color="color-black"/>
            <div id="home" className="fix">
                <ProfileSlide />
            </div>
            {/* End Slider Area   */} 

            {/* Start About Area */}
            <div id="about" className="fix">
                <div className="about-area ptb--120  bg_color--1">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/main-profile.jpg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        
                                        <div className="section-title">
                                            <h2 className="title">A bit about me</h2>
                                            <p className="description">{description}</p>
                                            <a href="/assets/file/Bryan Kenneth - Resume.pdf" target="_blank" className="rn-btn mr-2"><FiDownload /> My Resume</a>
                                            <a href="/assets/file/Bryan Kenneth - Technical Portfolio.pdf" target="_blank" className="rn-btn"><FiDownload /> Technical Portfolio</a>
                                        </div>

                                        <div className="row mt--30">
                                            
                                            <TabTwo tabStyle="tab-style--1" />
                                        </div>

                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* End About Area */}

            {/* Start Service Area  */}
            <div id="service" className="fix">
                <div className="service-area creative-service-wrapper pt--120 bg_color--5" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                    <h2 className="title">My Expertise</h2>
                                    {/* <p></p> */}
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            <div className="col-lg-12">
                                <ServiceList item="6" column="col-lg-4 col-md-6 col-sm-6 col-12 text-left" />
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            {/* End Service Area  */} 

             {/* Start Interest Area  */}
            <div id="interest" className="fix">
                <div className="service-area creative-service-wrapper ptb--120 bg_color--5" >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                    <h2 className="title">My Interest</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            <div className="col-lg-12">
                                <InterestList item="6" column="col-lg-4 col-md-6 col-sm-6 col-12 text-left" />
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            {/* End Interest Area  */} 


            {/* Start Portfolio Area */}
            <div id="portfolio" className="fix">
                <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="portfolio-sacousel-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                        <h2 className="title">Latest Projects</h2>
                                       
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <PortfolioList styevariation="text-center mt--40" column="col-lg-4 col-md-6 col-sm-6 col-12 text-center" item="3" />
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="view-more-btn mt--60 mt_sm--30 text-center">
                                        <a className="rn-button-style--2 btn-solid" href="/portfolio"><span>View More</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* End Portfolio Area */}

            {/* Start Blog Area */}
            {/* <div id="blog" className="fix">
                <div className="rn-blog-area ptb--120 bg_color--5 mb-dec--30">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="section-title text-center">
                                    <h2>Latest News</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, <br />but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--60 mt_sm--40">
                            {PostList.map((value , i ) => (
                                <div className="col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="blog blog-style--1">
                                        <div className="thumbnail">
                                            <a href="/blog-details">
                                                <img className="w-100" src={`/assets/images/blog/blog-${value.images}.jpg`} alt="Blog Images"/>
                                            </a>
                                        </div>
                                        <div className="content">
                                            <p className="blogtype">{value.category}</p>
                                            <h4 className="title"><a href="/blog-details">{value.title}</a></h4>
                                            <div className="blog-btn">
                                                <a className="rn-btn text-white" href="/blog-details">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>    
                    </div>    
                </div>
            </div> */}
            {/* End Blog Area */}

            {/* Start COntact Area */}
            <div id="contact" className="fix">
                <div className="rn-contact-area ptb--120 bg_color--1">
                    <ContactThree contactImages="/assets/images/about/about-9ss.png" contactTitle="Hire Me." />
                </div>
            </div>
            {/* End COntact Area */}

            <FooterTwo />
            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}
            
        </div>
    )
}

export default MainLandingPage;
